import { render, staticRenderFns } from "./RWPWGL.vue?vue&type=template&id=b6b8c894&scoped=true&"
import script from "./RWPWGL.vue?vue&type=script&lang=js&"
export * from "./RWPWGL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b8c894",
  null
  
)

export default component.exports